//Global Imports
import clsx from "clsx";
import React from "react";
import { Controller, useForm } from "react-hook-form";
//End Global Imports

//Local Imports
import Button from "../../../components/ui/Button";
import TextField from "../../../components/ui/TextField";
import { getErrorMessage, regexForEmailAddress } from "../../../utils";
//End Local Imports

type FormInputs = {
  email: string;
};

const StepOne = ({ registerEmail }: any) => {
  const {
    formState: { errors, isValid },
    handleSubmit,
    control,
  } = useForm<FormInputs>({ mode: "onChange" });

  return (
    <>
      <div className={clsx("pb-3 text-sm sm:text-base font-semibold text-black font-ssp md:pb-5")}>
        Enter your registered email
      </div>
      <form onSubmit={handleSubmit(registerEmail)} className="flex flex-col items-center">
        <div className="w-full sm:w-[372px] pb-9 sm:pb-[229px] mx-7 sm:mx-14">
          <Controller
            control={control}
            name="email"
            rules={{ required: true, pattern: regexForEmailAddress }}
            render={({ field: { name, value, onChange } }) => {
              return (
                <TextField
                  name={name}
                  type="email"
                  placeholder="Enter your email"
                  inputClasses={clsx(errors.email ? "border" : "border-none ", `bg-primary-350`)}
                  placeholderStyle="text-grey-200 font-ssp font-normal text-sm"
                  value={value}
                  onChange={(v) => onChange(v)}
                  // eslint-disable-next-line
                  errorMessage={getErrorMessage(
                    errors as Record<string, { type: any }>,
                    "email",
                    "Email",
                  )}
                  error={errors.email}
                  required
                  fullWidth
                />
              );
            }}
          />
        </div>
        <div>
          <Button
            bgColor={isValid ? "bg-primary-1050" : "bg-grey-150"}
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-lg",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="w-[307px] h-[50px] sm:h-[60px]"
            disabled={!isValid}
          >
            Confirm
          </Button>
        </div>
      </form>
    </>
  );
};

export default StepOne;
